// extracted by mini-css-extract-plugin
module.exports = {"header":"Stock_header__ruAR5","stockRoot":"Stock_stockRoot__Qp6Xc","filter":"Stock_filter__flfBO","active":"Stock_active__UhQ1R","boxHeight":"Stock_boxHeight__ZHp5D"};